
const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/27e10bb79a967cf7dbf5f8d790f41ea5.jpg"
          alt="AI Technology Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80"></div>
      </div>
      
      {/* X Pattern Overlay */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="xPattern" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
              <line x1="0" y1="0" x2="80" y2="80" stroke="#10B981" strokeWidth="1" />
              <line x1="80" y1="0" x2="0" y2="80" stroke="#10B981" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#xPattern)" />
        </svg>
      </div>

      {/* Floating X Elements */}
      <div className="absolute top-1/4 left-1/6 text-emerald-500/10 text-[200px] font-bold rotate-12 blur-sm">✕</div>
      <div className="absolute bottom-1/4 right-1/6 text-teal-500/10 text-[150px] font-bold -rotate-12 blur-sm">✕</div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <div className="mb-6">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full text-emerald-400 text-xs font-semibold uppercase tracking-widest">
            <span className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></span>
            Precision AI Systems
          </span>
        </div>

        <h1 className="text-6xl lg:text-8xl font-extrabold text-white mb-8 leading-tight tracking-tight">
          Where Intelligence<br />Becomes <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">Leverage.</span>
        </h1>
        
        <p className="text-lg lg:text-xl text-gray-300 max-w-3xl mx-auto mb-12 leading-relaxed font-light">
          CruxOnAI installs precision AI systems at the exact points where service businesses win or lose — removing bottlenecks, restoring control, and unlocking scalable growth.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <a
            href="/contact"
            className="px-10 py-4 bg-gradient-to-r from-emerald-500 to-teal-500 text-white font-bold rounded-lg hover:from-emerald-400 hover:to-teal-400 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-2xl shadow-emerald-500/30 hover:shadow-emerald-500/50 hover:scale-105 text-base"
          >
            Schedule a Strategy Call
          </a>
          <a
            href="/approach"
            className="px-10 py-4 bg-transparent border-2 border-emerald-500/50 text-emerald-400 font-bold rounded-lg hover:bg-emerald-500/10 hover:border-emerald-400 transition-all duration-300 whitespace-nowrap cursor-pointer text-base"
          >
            Explore Our Approach
          </a>
        </div>
      </div>

      {/* Bottom Gradient Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-zinc-950 to-transparent"></div>
    </section>
  );
};

export default HeroSection;
